import { Box } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { useSelector } from 'react-redux';

import {
	getHistoryMode,
	getIsTicketHistoryLoading,
	getTicketHistory,
} from 'store/ticket-service/selector';

import { HistoryChangesList } from 'components/ChangesVersioning/HistoryChangesList';
import { Header } from 'components/Header/MainHeader';
import { Sidebar } from 'components/Sidebar';

import * as Styled from './styled';

export const MainPageLayout = ({ children }: { children: ReactNode }) => {
	const isHistoryMode = useSelector(getHistoryMode);
	const ticketHistory = useSelector(getTicketHistory);
	const isHistoryLoading = useSelector(getIsTicketHistoryLoading);

	const [isShowDraft, setIsShowDraft] = useState(false);
	const [isCreating, setIsCreating] = useState(false);

	return (
		<Styled.PageContainer className="rtl-able">
			<Header isCreating={isCreating} />

			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					width: '100%',
					height: '100%',
					flex: 1,
					overflow: 'hidden',
				}}
				className="rtl-able"
			>
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						height: '100%',
						justifyContent: 'flex-start',
						overflow: 'hidden',
					}}
				>
					{isHistoryMode ? (
						<HistoryChangesList
							ticketHistory={ticketHistory}
							isHistoryLoading={isHistoryLoading}
						/>
					) : (
						<Sidebar
							isShowDraft={isShowDraft}
							setIsShowDraft={setIsShowDraft}
							isCreating={isCreating}
							setIsCreating={setIsCreating}
						/>
					)}

					<Box
						sx={{
							width: '100%',
							display: 'flex',
							//overflowY: 'auto',
							overflowX: 'hidden',
							backgroundColor: '#ffffff',
							boxSizing: 'border-box',
						}}
					>
						<Box
							position="relative"
							display={'flex'}
							flexDirection={'column'}
							flexGrow={1}
							height="100%"
						>
							{children}
						</Box>
					</Box>
				</Box>
			</Box>
		</Styled.PageContainer>
	);
};
